import { Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useFormikContext } from 'formik'
import {
  SemiConfigFormValues,
  useProductFromQueryParam,
  noClonesSelectedErrorMessage,
} from '../ProductsConfiguration'
import Species from './Species'
import GRnaCategory from './GRnaCategory'
import CircleLoader from '@src/components/CircleLoader'
import PreDesignedControls from './PreDesignedControls'
import StepTitle from '../StepTitle'
import SearchTerms from './SearchTerms'
import PageError from '../PageError'
import { SemiConfigProductTypes } from '../enum'
import SangerVector from './SangerVector'
import TrcVersionAndValidation from '../TrcVersionAndValidation'
import PreDesignedShRNA from './PreDesignedShRNA'
import PreDesignedGRna from './PreDesignedGRna'
import useSpecifications from '../useSpecifications'

const SelectClones = () => {
  const formik = useFormikContext<SemiConfigFormValues>()
  const product = useProductFromQueryParam()
  const errorMessage = noClonesSelectedErrorMessage(product)
  const { isORFVectorSelected } = useSpecifications()
  const shouldRenderComponents = (semiConfigProduct: string) => {
    const productsWithGRnaCategory = [
      SemiConfigProductTypes.PREDESIGNED_CRISPR_GRNA,
    ]

    const productsWithPreDesignedControls = [
      SemiConfigProductTypes.PREDESIGNED_CRISPR_GRNA,
    ]

    const productsWithTrcVersionAndValidation = [
      SemiConfigProductTypes.PREDESIGNED_SHRNA,
      SemiConfigProductTypes.ORF,
    ]

    return {
      shouldRenderCategory: productsWithGRnaCategory.includes(
        semiConfigProduct as SemiConfigProductTypes
      ),
      shouldRenderControls: productsWithPreDesignedControls.includes(
        semiConfigProduct as SemiConfigProductTypes
      ),
      shouldRenderTrcVersionAndValidation:
        productsWithTrcVersionAndValidation.includes(
          semiConfigProduct as SemiConfigProductTypes
        ),
    }
  }

  const {
    shouldRenderCategory,
    shouldRenderControls,
    shouldRenderTrcVersionAndValidation,
  } = shouldRenderComponents(product)

  return (
    <Grid container>
      <StepTitle
        title={
          <FormattedMessage
            id="CONF_Crispr_Search_Criteria_crisprgrna"
            defaultMessage="Search Criteria"
          />
        }
      />
      <Grid item xs={12}>
        <PageError
          showError={
            formik.values.displayPageError &&
            (formik.values.selectedClones.length === 0 ||
              isORFVectorSelected) &&
            formik.values.completedStep >= 1
          }
          errorMessage={!isORFVectorSelected && errorMessage}
          rootStyle={{ marginTop: '24px' }}
        />
      </Grid>
      <SearchTerms />
      <Species />
      {shouldRenderCategory && <GRnaCategory />}
      {shouldRenderControls && <PreDesignedControls />}
      {product === SemiConfigProductTypes.SANGERCRISPR && <SangerVector />}
      {shouldRenderTrcVersionAndValidation && <TrcVersionAndValidation />}
      {product === SemiConfigProductTypes.PREDESIGNED_SHRNA ? (
        <PreDesignedShRNA />
      ) : (
        <PreDesignedGRna />
      )}
      {formik.values?.loading && <CircleLoader />}
    </Grid>
  )
}

export default SelectClones
